import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const Actor = (props)=>{
    const { actor , lowerCase , currentUser  } = props;
    if (!actor) {
        if (lowerCase) return /*#__PURE__*/ _jsx(_Fragment, {
            children: "a deleted user"
        });
        else return /*#__PURE__*/ _jsx(_Fragment, {
            children: "A deleted user"
        });
    }
    if (currentUser && currentUser.id === actor.id) return lowerCase ? /*#__PURE__*/ _jsx(_Fragment, {
        children: "you"
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: "You"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: actor.username
    });
};
export default Actor;
